import React from "react";
import { AppCalendarEventsProvider, AppCalendarProvider } from "./@contexts";


export default function AppCalendarProviders({ children }) {


    return <AppCalendarProvider>
        <AppCalendarEventsProvider>
            {children}
        </AppCalendarEventsProvider>
    </AppCalendarProvider>
}

export { AppCalendarContext, AppCalendarEventsContext } from "./@contexts"